<template>
  <Panel class="battle-info-wrapper" variant="default">
    <div class="d-flex align-items-center justify-content-between">
      <Subheader
        :text="$t('_web_battle-info_header-label', 'Information')"
        class="battle-info-wrapper__title"
      />
      <HeraFormBtn
        v-if="rulesLink"
        icon="attach"
        icon-size="16"
        class="has-attach-icon d-flex align-items-center justify-content-around battle-info-wrapper__attachment mx-0"
      >
        <a class="text-white mx-1" :href="rulesLink" target="_blank">{{
          $t('_web_battle-info_info_attachment-btn', 'Format & Rules')
        }}</a>
      </HeraFormBtn>
    </div>

    <div class="row">
      <div class="col">
        <TextSection
          :title="$t('_web_battle-info_title-label', 'Battle ID')"
          :description="dynamicBattleModel.id"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <TextSection
          :title="$t('_web_battle-info_description-label', 'Tournament name')"
          :description="dynamicBattleModel.tournament.name"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-3 form-battle-text">
        <TextSection
          :title="$t('_web_battle-info_platform-label', 'Platform')"
          :description="platform.name"
        />
      </div>
      <div class="col-3 form-battle-text">
        <TextSection
          :title="$t('_web_battle-info_game-label', 'Game')"
          :description="game.name"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-3 form-battle-text">
        <TextSection
          :title="$t('_web_battle-info_country-label', 'Country')"
          :description="dynamicBattleModel.tournament.country"
        />
      </div>
      <div class="col-3 form-battle-text">
        <TextSection
          :title="$t('_web_battle-info_mode-label', 'Game mode')"
          :description="dynamicBattleModel.mode"
        />
      </div>
      <div class="col-3 form-battle-text">
        <TextSection
          :title="$t('_web_battle-info_type-label', 'Type')"
          :description="dynamicBattleModel.type"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <TextSection
          :title="$t('_web_battle-info_battle-starts', 'Battle starts')"
          :description="dynamicBattleModel.startDate | localDate(timeFormat)"
        />
      </div>
    </div>
  </Panel>
</template>

<script>
import Panel from '@/components/atoms/Panel';
import Subheader from '@/components/atoms/Subheader';
import TextSection from '@/components/text/TextSection';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import { mapGetters } from 'vuex';
import { isObject } from '@/utils/lodashUtils';
import { DateTime } from 'luxon';

export default {
  name: 'BattleInfo',
  components: {
    Panel,
    Subheader,
    TextSection,
    HeraFormBtn,
  },
  computed: {
    ...mapGetters(['platformByID', 'gameByID', 'dynamicBattleModel']),
    rulesLink() {
      return isObject(this.dynamicBattleModel.rules_link)
        ? this.dynamicBattleModel.rules_link.name
        : this.dynamicBattleModel.rules_link;
    },
    timeFormat() {
      return DateTime.DATETIME_FULL;
    },
    platform() {
      return this.platformByID(this.dynamicBattleModel.platform) || {};
    },
    game() {
      return this.gameByID(this.dynamicBattleModel.game) || {};
    },
  },
};
</script>

<style scoped lang="scss">
.battle-info-wrapper {
  &__title {
    margin-bottom: 20px;
  }
  &__attachment {
    padding: 0 0.5rem;
    height: 32px;
    line-height: 21px;
  }
}
@media (max-width: 767px) {
  .form-battle-text {
    max-width: 100%;
    flex: 0 0 100%;
  }
  .battle-info-wrapper {
    margin-bottom: 24px;
  }
}
</style>
